/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class DeleteService extends HttpHandlerService {
        constructor(
            $http: ng.IHttpService,
            private $q: angular.IQService,
            private modalService: any,
            private growl: angular.growl.IGrowlService,
            private dataService: services.DataService<breeze.Entity>) {
            super($http);
        }

        private delete(name: string, id: string): ng.IPromise<Wars.Domain.Model.Dtos.Delete.DeleteResult> {
            var params: any = { };
            this.handlerUrl = "api/Delete/SafeDelete/" + name + "/" + id;
            return this.usePostHandler(params);
        }

        public deleteRecursivelyWithoutWarning(name: string, id: string, ignoreUnsavedChanges: boolean): ng.IPromise<Wars.Domain.Model.Dtos.Delete.DeleteResult> {
            if (!ignoreUnsavedChanges && this.dataService.hasChanges()) {
                this.growl.error("Please save all in-work changes before attempting this delete action", { ttl: 5000 });
                var deferred = this.$q.defer();

                var failureResult: any = {
                    entityName: name,
                    entityId: id,
                    wasSuccessful: false,
                    inWorkChangesExist: true
                };

                deferred.resolve(failureResult);
                return deferred.promise;
            } 

            var params: any = {};
            this.handlerUrl = "api/Delete/RecursiveDelete/" + name + "/" + id;
            return this.usePostHandler(params);
        }

        public deleteBatchRecursivelyWithoutWarning(deleteInfo: Wars.Domain.Model.Dtos.Delete.DeleteInfoDto, ignoreUnsavedChanges: boolean): ng.IPromise<Wars.Domain.Model.Dtos.Delete.CombinedDeleteResult> {
            if (!ignoreUnsavedChanges && this.dataService.hasChanges()) {
                this.growl.error("Please save all in-work changes before attempting this delete action", { ttl: 5000 });
                var deferred = this.$q.defer();

                var failureResult: any = {
                    wasSuccessful: false,
                    inWorkChangesExist: true
                };

                deferred.resolve(failureResult);
                return deferred.promise;
            }

            this.handlerUrl = "api/Delete/RecursiveDeleteBundle";
            return this.usePostHandler(deleteInfo);
        }

        public deleteWithModalConfirmationIfNecessary(
            name: string,
            id: string,
            successMessage?: string,
            successCallback?: () => void,
            failureMessage?: string,
            failureCallback?: (result: Wars.Domain.Model.Dtos.Delete.DeleteResult) => void): void
        {
            if (this.dataService.hasChanges()) {
                this.growl.error("Please save all in-work changes before attempting this delete action", { ttl: 5000 });
                return;
            } else {
                this.delete(name, id).then((deleteResult) => {
                    if (deleteResult.wasSuccessful) {
                        this.processSuccessfulDelete(deleteResult, successMessage, successCallback);
                    } else {
                        this.showDeleteModal(deleteResult, successCallback, successMessage, failureCallback, failureMessage);
                    }
                });
            }
        }
//Use this one:
        public deleteWithModalConfirmIfNecessary(
            entityName: string,
            id: string,
            messagePrefix: string,
            successCallback?: () => void,
            failureCallback?: (result: Wars.Domain.Model.Dtos.Delete.DeleteResult) => void): void
        {
            this.deleteWithModalConfirmationIfNecessary(
                entityName,
                id,
                messagePrefix + " successfully deleted",
                successCallback,
                messagePrefix + " could not be deleted",
                failureCallback);
        }

        private processSuccessfulDelete(deleteResult: Wars.Domain.Model.Dtos.Delete.DeleteResult, successMessage?: string, successCallback?: () => void): void {
            if (successMessage) this.growl.success(successMessage, { ttl: 5000 });
            this.dataService.resolveDeletesAndUpdatesPerformedOutsideOfBreeze(deleteResult);
            if (successCallback) successCallback();
        }

        private showDeleteModal(
            deleteResult: Wars.Domain.Model.Dtos.Delete.DeleteResult,
            successCallback?: () => void,
            successMessage?: string,
            failureCallback?: (result: Wars.Domain.Model.Dtos.Delete.DeleteResult) => void,
            failureMessage?: string): void
        {
            this.modalService.showModal({
                templateUrl: "./app/views/modals/deleteModal.html",
                controller: "deleteModalController",
                size: 'lg',
                inputs: {
                    deleteResult: deleteResult
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    // Only true if not a cancel
                    if (result && result.cancel === false) {
                        if (result.deleteResult && result.deleteResult.wasSuccessful) {
                            this.processSuccessfulDelete(result.deleteResult, successMessage, successCallback);
                        } else {
                            if (failureMessage) this.growl.error(failureMessage, { ttl: 5000 });
                            if (failureCallback) failureCallback(result.deleteResult);
                        }
                    }
                });
            });
        }
    }
}

warsApp.registerService("DeleteService", ["$http", "$q", "ModalService", "growl", "dataService"]);